import { MaterialProperty } from '.prisma/client';
import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { of, Subject } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect,
} from '../../shared/crud/effects';
import { NoAudit } from '../../shared/interfaces/utils';
import {
  createItem,
  deleteItem,
  loadList,
  updateItem,
} from './material-property.actions';
import { MaterialPropertyRepository } from './material-property.repository';
import { MaterialPropertyService } from './material-property.service';

@Injectable({ providedIn: 'root' })
export class MaterialPropertyEffects {
  public notify$ = new Subject<{
    action: { type: string };
    payload?: unknown;
  }>();

  constructor(
    private repository: MaterialPropertyRepository,
    private service: MaterialPropertyService,
    private toast: HotToastService
  ) {}

  loadEntities$ = loadListEffect<NoAudit<MaterialProperty>>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<NoAudit<MaterialProperty>>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<NoAudit<MaterialProperty>>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<NoAudit<MaterialProperty>>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: MaterialProperty['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка показателя`));
        return this.service.findOne(id).pipe(
          tap((entity) => {
            if (!environment?.production) {
              this.toast.success(`Показатель загружен`);
            }
            if (entity) {
              this.repository.updateEntity(entity.id, entity);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
